import { render, staticRenderFns } from "./PublicDashboardPartner.vue?vue&type=template&id=48bf7a74"
import script from "./PublicDashboardPartner.vue?vue&type=script&lang=js"
export * from "./PublicDashboardPartner.vue?vue&type=script&lang=js"
import style0 from "./PublicDashboardPartner.vue?vue&type=style&index=0&id=48bf7a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports